import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { BillingOverviewSkeleton } from "@/app/billing/overview/components/billing-overview-skeleton";
import { BillingOverviewPage } from "@/app/billing/overview/overview";
import { RouteErrorBoundary } from "@/components/custom/router/route-error-boundary";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/billing/overview"
)({
  component: () => (
    <Suspense fallback={<BillingOverviewSkeleton />}>
      <BillingOverviewPage />
    </Suspense>
  ),
  errorComponent: RouteErrorBoundary,
  loader: () => ({
    crumb: "Overview",
  }),
});
